import styled from "styled-components";

import { LogoIcon } from "assets";

export type AuthorType = {
  avatar: React.ReactNode;
  name: string;
};

interface Props {
  author: AuthorType | undefined;
}

export const Author: React.VFC<Props> = ({ author }) => {
  const { avatar, name } = author || {};

  return (
    <Container>
      {avatar || (
        <AvatarContainer>
          <LogoIcon title="Joint Academy" />
        </AvatarContainer>
      )}
      <Name>{name || "Joint Academy"}</Name>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Name = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.black};
`;

const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  background-color: ${({ theme }) => theme.colors.redesign.db10};
  border-radius: 50%;

  & > svg {
    height: 20px;
  }
`;
